import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { ReuploadCadButton } from '@/pages/DocumentPage/components/ReuploadCadButton'
import { CadVersionProgressBar } from './CadVersionProgressBar'
import type { CADVersionProcessingStatus } from '@/lib/api/client'

export const CADVersionProcessingHelper = ({
  cadVersionId,
  status,
  hasNoDownloadUrl,
}: {
  cadVersionId: string | null | undefined
  status: CADVersionProcessingStatus | undefined
  hasNoDownloadUrl: boolean | undefined
}) => {
  const showReuploadButton =
    (status === 'completed' && hasNoDownloadUrl) ||
    status === 'error' ||
    status === 'no file' ||
    status === 'new'

  const showProgressBar = !showReuploadButton && status === 'uploaded'

  return (
    <div className="flex flex-col w-full">
      <div className="flex flex-col mt-16 items-center">
        {showProgressBar && <CadVersionProgressBar />}
        {showReuploadButton && (
          <>
            <ExclamationTriangleIcon className="h-8 w-8 text-red-500" />
            <h1 className="text-lg">Uploading CAD file was unsuccessful.</h1>
            {cadVersionId && (
              <>
                <h2 className="text-lg">Please attempt to upload again.</h2>
                <div className="mt-6">
                  <ReuploadCadButton cadVersionId={cadVersionId} />
                </div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  )
}
